import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--font-size": "0.875rem",
          "--description-font-size": "0.75rem",
          "--description-color": "var(--muted-foreground)",
          "--description-font-weight": "400",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
